import * as yup from 'yup';

import { ObjectTypeBase } from '../../baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../Property';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import { createShapeFromProperties } from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  name: {
    type: 'String',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  type: {
    type: 'String',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  uri: {
    type: 'String',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
};

export class LinkType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];

  name = 'Link';

  friendlyName = 'Link';
  properties = properties;

  get example() {
    return 'https://activate.vts.com/';
  }

  get default(): any {
    return {
      _id: null,
      name: null,
      type: null,
      uri: null,
    };
  }

  buildSchema() {
    return yup.object().shape(createShapeFromProperties(properties)).nullable();
  }
}

const definition = new LinkType();

Types.addBaseType(definition);
export { definition as LinkDefinition };
